import { isBlank } from 'helpers/string_helpers';

export function booleanToString(boolean) {
  return boolean ? '1' : undefined;
}

export function stringToBoolean(string) {
  return string === '1';
}

export function arrayToString(array) {
  return array ? array.join(',') : '';
}

export function stringToArray(str) {
  str = str.trim();
  return str === '' ? [] : str.split(',');
}

export function objectToString(obj) {
  return obj ? JSON.stringify(obj) : '';
}

export function stringToObject(str) {
  return isBlank(str) ? {} : JSON.parse(str);
}

export function stringToNumberArray(str) {
  str = str.trim();
  return str === '' ? [] : str.split(',').map(Number);
}

export function stringToUrl(str) {
  str = str.trim();
  return str.match(/^https?:\/\//) ? str : `http://${str}`;
}

export function pluralize(count, noun, suffix = 's') {
  return `${count} ${noun}${count !== 1 ? suffix : ''}`;
}

export function snakeCase(string) {
  return string.replace(/\W+/g, ' ')
    .split(/ |\B(?=[A-Z])/)
    .map(word => word.toLowerCase())
    .join('_');
}

export function htmlToString(html) {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.textContent || '';
}

export function titleize(string) {
  if (!string || string.match(/^[_\s]+$/)) return '';

  return string.trim()
    .split(/[_\s]+/)
    .map(word => word[0].toUpperCase() + word.slice(1))
    .join(' ');
}

/**
 * Joins an array of strings with commas and "and" before the last element (Oxford comma style).
 * @param {Array<string>} array - The array of strings to join
 * @returns {string} - The formatted string
 *
 * Examples:
 * - joinWithAnd(['PDF']) => 'PDF'
 * - joinWithAnd(['PDF', 'Word']) => 'PDF and Word'
 * - joinWithAnd(['PDF', 'Excel', 'Powerpoint']) => 'PDF, Excel, and Powerpoint'
 */
export function joinWithAnd(array) {
  if (!array || array.length === 0) return '';
  if (array.length === 1) return array[0];
  if (array.length === 2) return array.join(' and ');
  return `${array.slice(0, -1).join(', ')}, and ${array.slice(-1)}`;
}
